export const PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT =
  'cantilever:component-artifacts:edit'
export const PERMISSION_CANTILEVER_MARKUP_LAYER_EDIT =
  'cantilever:markup-layer:edit'
export const PERMISSION_GECKO_READ = 'gecko:read'
export const PERMISSION_GECKO_INTERNAL_MEMBER = 'gecko:internal:member'
export const PERMISSION_GECKO_FIM_ADMIN = 'gecko:fim:admin'
export const PERMISSION_CANTILEVER_LABELING_EDIT = 'cantilever:labeling:edit'
export const PERMISSION_LIBRA_EXECUTIVE = 'libra-executive'
export const PERMISSION_MODUS = 'modus'
export const PERMISSION_CANTILEVER_PUBLISHER_ARCHIVE_EDITOR =
  'cantilever:publisher-archive:editor'
export const PERMISSION_CANTILEVER_ACCESS_ADMIN = 'cantilever:access:admin'
export const PERMISSION_CANTILEVER_ACCESS_EDITOR = 'cantilever:access:editor'
export const PERMISSION_CANTILEVER_ACCESS_VIEWER = 'cantilever:access:viewer'
export const PERMISSION_CANTILEVER_ACCESS_MEMBER = 'cantilever:access:member'
export const PERMISSION_CANTILEVER_CORE_EDIT = 'cantilever:core:edit'
export const PERMISSION_CANTILEVER_CORE_ADMIN = 'cantilever:core:admin'
export const PERMISSION_CANTILEVER_ASSET_OVERVIEW_VIEWER =
  'cantilever:asset-overview:viewer'
export const PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR =
  'cantilever:asset-overview:editor'
export const PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN =
  'cantilever:asset-overview:admin'
export const PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_VIEWER =
  'cantilever:inspection-overview:viewer'
export const PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_EDITOR =
  'cantilever:inspection-overview:editor'
export const PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_ADMIN =
  'cantilever:inspection-overview:admin'
export const PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_VIEWER =
  'cantilever:inventory-management:viewer'
export const PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_EDITOR =
  'cantilever:inventory-management:editor'
export const PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_ADMIN =
  'cantilever:inventory-management:admin'
export const PERMISSION_CANTILEVER_HEALTH_PLAN_EDITOR =
  'cantilever:health-plan:editor'
export const PERMISSION_CANTILEVER_HEALTH_PLAN_VIEWER =
  'cantilever:health-plan:viewer'
export const PERMISSION_CANTILEVER_BUDGETING_EDITOR =
  'cantilever:budgeting:editor'
export const PERMISSION_CANTILEVER_BUDGETING_VIEWER =
  'cantilever:budgeting:viewer'
export const PERMISSION_CANTILEVER_EXPLORER_EDITOR =
  'cantilever:explorer:editor'
export const PERMISSION_CANTILEVER_EXPLORER_VIEWER =
  'cantilever:explorer:viewer'
export const PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_EDITOR =
  'cantilever:inspection-scheduling:editor'
export const PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_VIEWER =
  'cantilever:inspection-scheduling:viewer'
export const PERMISSION_CANTILEVER_PARTS_THREAD_EDITOR =
  'cantilever:parts-thread:editor'
export const PERMISSION_CANTILEVER_PARTS_THREAD_VIEWER =
  'cantilever:parts-thread:viewer'
export const PERMISSION_CANTILEVER_FORGING_CREATOR =
  'cantilever:forging:creator'
export const PERMISSION_CANTILEVER_PHOTOGRAMMETRY_EDITOR =
  'cantilever:photogrammetry:editor'
export const PERMISSION_CANTILEVER_PHOTOGRAMMETRY_ADMIN =
  'cantilever:photogrammetry:admin'
export const PERMISSION_CANTILEVER_KESTREL_EDITOR_ADMIN =
  'cantilever:kestrel-editor:admin'
export const PERMISSION_CANTILEVER_PUBLISHER_VIEWER =
  'cantilever:publisher:viewer'
export const PERMISSION_CANTILEVER_PUBLISHER_EDITOR =
  'cantilever:publisher:editor'
export const PERMISSION_CANTILEVER_PUBLISHER_ADMIN =
  'cantilever:publisher:admin'

export const PERMISSION_CANTILEVER_EXTENSION_CONFIG_EDITOR =
  'cantilever:extension-configuration:editor'
export const PERMISSION_CANTILEVER_PROCESS_FLOW_EDITOR =
  'cantilever:process-flow:editor'
export const PERMISSION_CANTILEVER_PROCESS_FLOW_VIEWER =
  'cantilever:process-flow:viewer'
export const PERMISSION_CANTILEVER_PROCESS_FLOW_ADMIN =
  'cantilever:process-flow:admin'

export const PERMISSION_CANTILEVER_DELPHI_VIEWER = 'cantilever:delphi:viewer'
export const PERMISSION_CANTILEVER_TIME_SERIES_EDITOR =
  'cantilever:time-series:editor'

export const PERMISSION_CANTILEVER_SYSTEM_VIEWER =
  'cantilever:system-view:viewer'

export const PERMISSION_CANTILEVER_POSTS_VIEWER = 'cantilever:posts:viewer'
export const PERMISSION_CANTILEVER_POSTS_EDITOR = 'cantilever:posts:editor'
export const PERMISSION_CANTILEVER_VALUE_STORY_ADMIN =
  'cantilever:value-story:admin'

export const PERMISSION_MATTERPORT_WALKTHROUGH_VIEWER =
  'cantilever:matterport-walkthrough:viewer'

export const PERMISSION_CANTILEVER_ANOMALY_DETECTION_EDITOR =
  'cantilever:anomaly-detection:editor'

export const PERMISSION_CANTILEVER_CASES_EDITOR = 'cantilever:cases:editor'
export const PERMISSION_CANTILEVER_CASES_VIEWER = 'cantilever:cases:viewer'
export const ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_VIEWER =
  'cantilever:document-navigator:viewer'
export const ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_UPLOADER =
  'cantilever:document-navigator:uploader'
export const ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_EDITOR =
  'cantilever:document-navigator:editor'
export const ROLE_CANTILEVER_DOCCHAT_BETA_VIEWER =
  'cantilever:docchat-beta:viewer'
export const PERMISSION_CANTILEVER_SINGAPORE_MEMBER =
  'cantilever:singapore:member'
export const PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_VIEWER =
  'cantilever:power-document-navigator:viewer'
export const PERMISSION_CANTILEVER_LOTO_VIEWER = 'cantilever:loto:viewer'
export const PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR =
  'cantilever:power-document-navigator:editor'
export const PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN =
  'cantilever:power-document-navigator:admin'
export const PERMISSION_CANTILEVER_POWER_SUBJECTS_VIEWER =
  'cantilever:power-subjects:viewer'
export const PERMISSION_CANTILEVER_DOCCHAT_REVISIONS_VIEWER =
  'cantilever:docchat-revisions:viewer'
export const PERMISSION_CANTILEVER_POWER_FIM_VIEWER =
  'cantilever:power-fim:viewer'
export const PERMISSION_CANTILEVER_POWER_MODEL_BUILDER_EDITOR =
  'cantilever:power-model-builder:editor'
export const PERMISSION_CANTILEVER_POWER_CONVERSATION_REVIEW_VIEWER =
  'cantilever:power-conversation-review:viewer'
export const PERMISSION_CANTILEVER_PRODUCTION_DASHBOARD_VIEWER =
  'cantilever:navy-production-dashboard:viewer'
export const PERMISSION_CANTILEVER_PRODUCTION_DASHBOARD_EDITOR =
  'cantilever:navy-production-dashboard:editor'
export const PERMISSION_CANTILEVER_NAVY_SHIPS_VIEWER =
  'cantilever:navy-ships:viewer'
export const PERMISSION_CANTILEVER_VIRTUAL_REPORTS_VIEWER =
  'cantilever:virtual-reports:viewer'
export const PERMISSION_NII_EDITOR = 'nii-editor'
export const PERMISSION_CANTILEVER_CHAT_USER = 'cantilever:chat:user'
export const PERMISSION_CANTILEVER_DOC_CHAT_CROSS_REFERENCE_VIEWER =
  'cantilever:doc-chat-cross-reference:viewer'
export const PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_VIEWER =
  'cantilever:doc-metadata-user-edits:viewer'
export const PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_EDITOR =
  'cantilever:doc-metadata-user-edits:editor'
export const PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_LABELER =
  'cantilever:doc-metadata-user-edits:labeler'
export const PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_REVIEWER =
  'cantilever:doc-metadata-user-edits:reviewer'
export const PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_DASHBOARD =
  'cantilever:doc-metadata-user-edits:dashboard'
export const PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_DASHBOARD =
  'cantilever:agents-evaluations:dashboard'
export const PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_EDITOR =
  'cantilever:agents-evaluations:editor'
export const PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_CURATOR =
  'cantilever:agents-evaluations:curator'
export const PERMISSION_GECKO_COST_METRICS_VIEW = 'gecko:cost-metrics:view'
export const PERMISSION_GECKO_COST_METRICS_ADMIN = 'gecko:cost-metrics:admin'
// List of all permission values for UI components (e.g., dropdowns)
// TODO: Remember to add new permissions here when creating them above
export const ALL_STATIC_PERMISSION_VALUES = [
  PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT,
  PERMISSION_CANTILEVER_MARKUP_LAYER_EDIT,
  PERMISSION_GECKO_READ,
  PERMISSION_GECKO_INTERNAL_MEMBER,
  PERMISSION_GECKO_FIM_ADMIN,
  PERMISSION_CANTILEVER_LABELING_EDIT,
  PERMISSION_GECKO_COST_METRICS_VIEW,
  PERMISSION_GECKO_COST_METRICS_ADMIN,
  PERMISSION_LIBRA_EXECUTIVE,
  PERMISSION_MODUS,
  PERMISSION_CANTILEVER_PUBLISHER_ARCHIVE_EDITOR,
  PERMISSION_CANTILEVER_ACCESS_ADMIN,
  PERMISSION_CANTILEVER_ACCESS_EDITOR,
  PERMISSION_CANTILEVER_ACCESS_VIEWER,
  PERMISSION_CANTILEVER_ACCESS_MEMBER,
  PERMISSION_CANTILEVER_CORE_EDIT,
  PERMISSION_CANTILEVER_CORE_ADMIN,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_VIEWER,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN,
  PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_VIEWER,
  PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_EDITOR,
  PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_ADMIN,
  PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_VIEWER,
  PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_EDITOR,
  PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_ADMIN,
  PERMISSION_CANTILEVER_HEALTH_PLAN_EDITOR,
  PERMISSION_CANTILEVER_HEALTH_PLAN_VIEWER,
  PERMISSION_CANTILEVER_BUDGETING_EDITOR,
  PERMISSION_CANTILEVER_BUDGETING_VIEWER,
  PERMISSION_CANTILEVER_EXPLORER_EDITOR,
  PERMISSION_CANTILEVER_EXPLORER_VIEWER,
  PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_EDITOR,
  PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_VIEWER,
  PERMISSION_CANTILEVER_PARTS_THREAD_EDITOR,
  PERMISSION_CANTILEVER_PARTS_THREAD_VIEWER,
  PERMISSION_CANTILEVER_FORGING_CREATOR,
  PERMISSION_CANTILEVER_PHOTOGRAMMETRY_EDITOR,
  PERMISSION_CANTILEVER_PHOTOGRAMMETRY_ADMIN,
  PERMISSION_CANTILEVER_KESTREL_EDITOR_ADMIN,
  PERMISSION_CANTILEVER_PUBLISHER_VIEWER,
  PERMISSION_CANTILEVER_PUBLISHER_EDITOR,
  PERMISSION_CANTILEVER_PUBLISHER_ADMIN,
  PERMISSION_CANTILEVER_EXTENSION_CONFIG_EDITOR,
  PERMISSION_CANTILEVER_PROCESS_FLOW_EDITOR,
  PERMISSION_CANTILEVER_PROCESS_FLOW_VIEWER,
  PERMISSION_CANTILEVER_PROCESS_FLOW_ADMIN,
  PERMISSION_CANTILEVER_DELPHI_VIEWER,
  PERMISSION_CANTILEVER_TIME_SERIES_EDITOR,
  PERMISSION_CANTILEVER_SYSTEM_VIEWER,
  PERMISSION_CANTILEVER_POSTS_VIEWER,
  PERMISSION_CANTILEVER_POSTS_EDITOR,
  PERMISSION_CANTILEVER_VALUE_STORY_ADMIN,
  PERMISSION_MATTERPORT_WALKTHROUGH_VIEWER,
  PERMISSION_CANTILEVER_ANOMALY_DETECTION_EDITOR,
  PERMISSION_CANTILEVER_CASES_EDITOR,
  PERMISSION_CANTILEVER_CASES_VIEWER,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_VIEWER,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_UPLOADER,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_EDITOR,
  ROLE_CANTILEVER_DOCCHAT_BETA_VIEWER,
  PERMISSION_CANTILEVER_SINGAPORE_MEMBER,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_VIEWER,
  PERMISSION_CANTILEVER_LOTO_VIEWER,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN,
  PERMISSION_CANTILEVER_POWER_SUBJECTS_VIEWER,
  PERMISSION_CANTILEVER_DOCCHAT_REVISIONS_VIEWER,
  PERMISSION_CANTILEVER_POWER_FIM_VIEWER,
  PERMISSION_CANTILEVER_POWER_MODEL_BUILDER_EDITOR,
  PERMISSION_CANTILEVER_POWER_CONVERSATION_REVIEW_VIEWER,
  PERMISSION_CANTILEVER_PRODUCTION_DASHBOARD_VIEWER,
  PERMISSION_CANTILEVER_PRODUCTION_DASHBOARD_EDITOR,
  PERMISSION_CANTILEVER_NAVY_SHIPS_VIEWER,
  PERMISSION_CANTILEVER_VIRTUAL_REPORTS_VIEWER,
  PERMISSION_NII_EDITOR,
  PERMISSION_CANTILEVER_CHAT_USER,
  PERMISSION_CANTILEVER_DOC_CHAT_CROSS_REFERENCE_VIEWER,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_VIEWER,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_EDITOR,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_LABELER,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_REVIEWER,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_DASHBOARD,
  PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_DASHBOARD,
  PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_EDITOR,
  PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_CURATOR,
] as const

// External user permissions
type SiteEditPermission = `rolodex:site:${string}:edit`
type SiteEditorPermission = `rolodex:site:${string}:editor`
type SiteMemberPermission = `rolodex:site:${string}:member`
type OrgMemberPermission = `rolodex:organization:${string}:member`
type OrgEditPermission = `rolodex:organization:${string}:edit`
type OrgAdminPermission = `rolodex:organization:${string}:admin`

// Libra ticket-group scoped permissions
const LIBRA_TICKET_GROUP_PREFIX = 'cantilever:libra-ticket-group'

/**
 * Every group-scoped Libra role. The permission type, the builder and the
 * bare-form scoping all derive from this, so a new role needs only an entry
 * here.
 */
export const LIBRA_TICKET_GROUP_ROLES = [
  'admin',
  'editor',
  'reviewer',
  'signoff-sme-reviewer',
  'signoff-org-reviewer',
  'signoff-site-reviewer',
] as const

export type LibraTicketGroupRole = (typeof LIBRA_TICKET_GROUP_ROLES)[number]

type LibraTicketGroupPermission =
  `${typeof LIBRA_TICKET_GROUP_PREFIX}:${string}:${LibraTicketGroupRole}`

export function getSiteEditPermission(siteId: string): SiteEditPermission {
  return `rolodex:site:${siteId}:edit`
}

export function getSiteEditorPermission(siteId: string): SiteEditorPermission {
  return `rolodex:site:${siteId}:editor`
}

export function getSiteMemberPermission(siteId: string): SiteMemberPermission {
  return `rolodex:site:${siteId}:member`
}
export function getOrgMemberPermission(orgId: string): OrgMemberPermission {
  return `rolodex:organization:${orgId}:member`
}

export function getOrgEditPermission(orgId: string): OrgEditPermission {
  return `rolodex:organization:${orgId}:edit`
}

export function getOrgAdminPermission(orgId: string): OrgAdminPermission {
  return `rolodex:organization:${orgId}:admin`
}

export function getLibraTicketGroupPermission(
  ticketGroupId: string,
  libraTicketGroupRole: LibraTicketGroupRole
): LibraTicketGroupPermission {
  return `${LIBRA_TICKET_GROUP_PREFIX}:${ticketGroupId}:${libraTicketGroupRole}`
}

/** Named alias: callers check the group superuser on its own. */
export function getLibraTicketGroupAdminPermission(
  ticketGroupId: string
): LibraTicketGroupPermission {
  return getLibraTicketGroupPermission(ticketGroupId, 'admin')
}

export function isLibraTicketGroupRole(
  value: string
): value is LibraTicketGroupRole {
  return (LIBRA_TICKET_GROUP_ROLES as ReadonlyArray<string>).includes(value)
}

/**
 * Fills a group id into the bare form a workflow config may use
 * (`cantilever:libra-ticket-group:<role>`). Anything else — already-scoped
 * strings, unknown roles, other namespaces — passes through untouched, so a
 * typo'd role stays a literal that never matches.
 */
export function scopeLibraTicketGroupPermission(
  permission: string,
  ticketGroupId: string
): string {
  if (!permission.startsWith(`${LIBRA_TICKET_GROUP_PREFIX}:`)) return permission
  const roleSegment = permission.slice(LIBRA_TICKET_GROUP_PREFIX.length + 1)
  return isLibraTicketGroupRole(roleSegment)
    ? getLibraTicketGroupPermission(ticketGroupId, roleSegment)
    : permission
}

export const geckoPerms = [
  PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT,
  PERMISSION_CANTILEVER_CORE_EDIT,
  PERMISSION_GECKO_READ,
  PERMISSION_GECKO_INTERNAL_MEMBER,
  PERMISSION_GECKO_FIM_ADMIN,
]

export type RolodexPermissionsValues =
  | typeof PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT
  | typeof PERMISSION_CANTILEVER_MARKUP_LAYER_EDIT
  | typeof PERMISSION_GECKO_READ
  | typeof PERMISSION_GECKO_INTERNAL_MEMBER
  | typeof PERMISSION_GECKO_FIM_ADMIN
  | typeof PERMISSION_CANTILEVER_LABELING_EDIT
  | typeof PERMISSION_GECKO_COST_METRICS_VIEW
  | typeof PERMISSION_GECKO_COST_METRICS_ADMIN
  | typeof PERMISSION_LIBRA_EXECUTIVE
  | typeof PERMISSION_MODUS
  | typeof PERMISSION_CANTILEVER_PUBLISHER_ARCHIVE_EDITOR
  | typeof PERMISSION_CANTILEVER_ACCESS_ADMIN
  | typeof PERMISSION_CANTILEVER_ACCESS_EDITOR
  | typeof PERMISSION_CANTILEVER_ACCESS_VIEWER
  | typeof PERMISSION_CANTILEVER_ACCESS_MEMBER
  | typeof PERMISSION_CANTILEVER_CORE_EDIT
  | typeof PERMISSION_CANTILEVER_CORE_ADMIN
  | typeof PERMISSION_CANTILEVER_ASSET_OVERVIEW_VIEWER
  | typeof PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR
  | typeof PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN
  | typeof PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_VIEWER
  | typeof PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_EDITOR
  | typeof PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_ADMIN
  | typeof PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_VIEWER
  | typeof PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_EDITOR
  | typeof PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_ADMIN
  | typeof PERMISSION_CANTILEVER_HEALTH_PLAN_EDITOR
  | typeof PERMISSION_CANTILEVER_HEALTH_PLAN_VIEWER
  | typeof PERMISSION_CANTILEVER_BUDGETING_EDITOR
  | typeof PERMISSION_CANTILEVER_BUDGETING_VIEWER
  | typeof PERMISSION_CANTILEVER_EXPLORER_EDITOR
  | typeof PERMISSION_CANTILEVER_EXPLORER_VIEWER
  | typeof PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_EDITOR
  | typeof PERMISSION_CANTILEVER_INSPECTION_SCHEDULING_VIEWER
  | typeof PERMISSION_CANTILEVER_PARTS_THREAD_EDITOR
  | typeof PERMISSION_CANTILEVER_PARTS_THREAD_VIEWER
  | typeof PERMISSION_CANTILEVER_FORGING_CREATOR
  | typeof PERMISSION_CANTILEVER_EXTENSION_CONFIG_EDITOR
  | typeof PERMISSION_CANTILEVER_PHOTOGRAMMETRY_EDITOR
  | typeof PERMISSION_CANTILEVER_PHOTOGRAMMETRY_ADMIN
  | typeof PERMISSION_CANTILEVER_KESTREL_EDITOR_ADMIN
  | typeof PERMISSION_CANTILEVER_PUBLISHER_VIEWER
  | typeof PERMISSION_CANTILEVER_PUBLISHER_EDITOR
  | typeof PERMISSION_CANTILEVER_PUBLISHER_ADMIN
  | SiteEditPermission
  | SiteEditorPermission
  | SiteMemberPermission
  | OrgMemberPermission
  | OrgEditPermission
  | OrgAdminPermission
  | typeof PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN
  | typeof PERMISSION_CANTILEVER_PROCESS_FLOW_EDITOR
  | typeof PERMISSION_CANTILEVER_PROCESS_FLOW_VIEWER
  | typeof PERMISSION_CANTILEVER_PROCESS_FLOW_ADMIN
  | typeof PERMISSION_CANTILEVER_DELPHI_VIEWER
  | typeof PERMISSION_CANTILEVER_TIME_SERIES_EDITOR
  | typeof PERMISSION_CANTILEVER_SYSTEM_VIEWER
  | typeof PERMISSION_CANTILEVER_POSTS_VIEWER
  | typeof PERMISSION_CANTILEVER_POSTS_EDITOR
  | typeof PERMISSION_CANTILEVER_VALUE_STORY_ADMIN
  | typeof PERMISSION_MATTERPORT_WALKTHROUGH_VIEWER
  | typeof PERMISSION_CANTILEVER_ANOMALY_DETECTION_EDITOR
  | typeof PERMISSION_CANTILEVER_CASES_EDITOR
  | typeof PERMISSION_CANTILEVER_CASES_VIEWER
  | typeof ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_VIEWER
  | typeof ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_UPLOADER
  | typeof ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_EDITOR
  | typeof ROLE_CANTILEVER_DOCCHAT_BETA_VIEWER
  | typeof PERMISSION_CANTILEVER_SINGAPORE_MEMBER
  | typeof PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_VIEWER
  | typeof PERMISSION_CANTILEVER_LOTO_VIEWER
  | typeof PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR
  | typeof PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN
  | typeof PERMISSION_CANTILEVER_POWER_SUBJECTS_VIEWER
  | typeof PERMISSION_CANTILEVER_DOCCHAT_REVISIONS_VIEWER
  | typeof PERMISSION_CANTILEVER_POWER_FIM_VIEWER
  | typeof PERMISSION_CANTILEVER_POWER_MODEL_BUILDER_EDITOR
  | typeof PERMISSION_CANTILEVER_POWER_CONVERSATION_REVIEW_VIEWER
  | typeof PERMISSION_CANTILEVER_PRODUCTION_DASHBOARD_VIEWER
  | typeof PERMISSION_CANTILEVER_PRODUCTION_DASHBOARD_EDITOR
  | typeof PERMISSION_CANTILEVER_NAVY_SHIPS_VIEWER
  | typeof PERMISSION_CANTILEVER_VIRTUAL_REPORTS_VIEWER
  | typeof PERMISSION_NII_EDITOR
  | typeof PERMISSION_CANTILEVER_CHAT_USER
  | typeof PERMISSION_CANTILEVER_DOC_CHAT_CROSS_REFERENCE_VIEWER
  | typeof PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_VIEWER
  | typeof PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_EDITOR
  | typeof PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_LABELER
  | typeof PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_REVIEWER
  | typeof PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_DASHBOARD
  | typeof PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_DASHBOARD
  | typeof PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_EDITOR
  | typeof PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_CURATOR
  | LibraTicketGroupPermission
